module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"issue","description":"A currency-counterparty pair, or just currency if it's XRP","allOf":[{"$ref":"amountbase"},{"not":{"required":["value"]}}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/issue.json
// module id = YSip
// module chunks = 1